import './title.less'

import React, {HTMLProps} from 'react'
import {style} from 'util/style'
import {Trusted} from 'util/trusted'
import {Theme} from 'views/theme'

const styles = style('title')

export const Title: React.FC<HTMLProps<HTMLDivElement> & {
	title: string
	subtitle?: string
	align?: 'center'
}> = ({title, subtitle, align, ...props}) => {
	const isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i)

	return (
		<div
			className={styles()
				.mod(align)
				.mergeProps(props)}
		>
			{title && (
				<Theme.H1 as="h2" className={styles('title')} mod={['dots']}>
					{isHTML(title) ? <Trusted>{title}</Trusted> : title}
				</Theme.H1>
			)}
			{subtitle && <h3 className={styles('subtitle')}>{subtitle}</h3>}
		</div>
	)
}
